import toastr from "@modules/toastr"
import moment from "moment"
import { useEffect, useState } from "react"
import Swal from "sweetalert2"

// Modify Sessions
const SessionTableModify = ({ getServiceName, closeModal }) => {
  const [metaData, setMetaData] = useState(null)
  const [customSessions, setCustomSessions] = useState([])
  const [newSession, setNewSession] = useState({session_type: '', session_numb: '', month_start: '', month_end: '',
                                                date_start: '', date_end: '', time_start: '', time_end: '', days: [], active: true})
  const [toggleDaysModal, setToggleDaysModal] = useState(false)
  const [selectedSession, setSelectedSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function getSessions() {
      setLoading(true)
      const { data } = await $app.axios.get(
        `/services/metadata?service[name]=${getServiceName()}`
      )

      const bahamahost_data = data.metadata?.find(
        m => m.desc == 'bahamahost session desc'
      ) || data.metadata?.find(
        m => m.desc == 'bahamahost companies corporate session desc'
      )
      setMetaData(bahamahost_data)

      // console.log('session data: ', bahamahost_data)
      const sortedSessions = bahamahost_data?.data?.map((x, index) => ({...x, sort_by: x.session_numb.replace(/\D/g, ''), id: index}))
        .sort((a, b) => a.sort_by - b.sort_by)

      setCustomSessions(sortedSessions)
      setLoading(false)
      // console.log('customSessions data: ', customSessions)

    }

    getSessions()
  }, [getServiceName])

  const sessionNumbPrefix = (session) => {
    switch (session?.session_type) {
      case 'BHD':
        return 'B'
      case 'BHE':
        return 'B'
      case 'BI':
        return 'BI'
      case 'BHR':
        return 'BR'
      case 'BHT':
        return 'TG'
    
      default:
        return 'B'
    }
  }

  const setDateButtonText = (session) => {
    if (session?.month_start == '' || session?.month_end == '') {
      return 'Set Month/Date'
    } else {
      return `${session?.month_start} ${session?.date_start} - ${session?.month_end} ${session?.date_end}`
    }
  }

  const setTimeButtonText = (session) => {
    if (session?.time_start == '' || session?.time_end == '') {
      return 'Set Time'
    } else {
      return `${session?.time_start} - ${session?.time_end}`
    }
  }

  const setDaysAvailableText = (session) => {
    if (session?.days?.length < 1) {
      return 'Set Days'
    } else {
      return session?.days?.join(', ')
    }
  }

  const on = {
    setInput: (val, i, key) => {
      const newHistory = [...customSessions];

      if (key === 'session_type') {
        newHistory[i][key] = val;
        newHistory[i]['session_numb'] = sessionNumbPrefix(newHistory[i]) + newHistory[i].session_numb.replace(/\D/g, '')
      } else {
        newHistory[i][key] = val;
      }

      setCustomSessions(newHistory);
    }
  }

  const setDate = (session, index = null) => {
    const sessionDateStart = session?.month_start && session?.date_start ? moment(`${session.month_start} ${session.date_start}`, 'MMMM D') : null
    const sessionDateEnd = session?.month_end && session?.date_end ? moment(`${session.month_end} ${session.date_end}`, 'MMMM D') : null

    Swal.fire({
      title: 'Edit Session Dates',
      html:
        `<div class='d-flex flex-row align-items-center justify-content-center'>
          <div class='form-group'>
            <label for='month_start'>Start Month/Date</label>
            <input type='date' id='month_date_start' class='form-control' value='${sessionDateStart ? sessionDateStart.format('YYYY-MM-DD') : ''}' />
          </div>
          <div class='form-group'>
            <label for='month_end'>End Month/Date</label>
            <input type='date' id='month_date_end' class='form-control' value='${sessionDateEnd ? sessionDateEnd.format('YYYY-MM-DD') : ''}' />
          </div>
        </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        const start_val = document.getElementById('month_date_start').value
        const end_val = document.getElementById('month_date_end').value
        const month_start = start_val ? moment(start_val).format('MMMM') : ''
        const month_end = end_val ? moment(end_val).format('MMMM') : ''
        const date_start = start_val ? moment(start_val).format('D') : ''
        const date_end = end_val ? moment(end_val).format('D') : ''

        // console.log('selected dates: ', month_start, date_start, ' - ', month_end, date_end)

        if (index) {
          on.setInput(month_start, index, 'month_start')
          on.setInput(date_start, index, 'date_start')
          on.setInput(month_end, index, 'month_end')
          on.setInput(date_end, index, 'date_end')
        } else {
          setNewSession((prevState) => ({
            ...prevState,
            month_start,
            date_start,
            month_end,
            date_end
          }))
        }
      }
    })
  }

  const setTime = (session, index = null) => {
    Swal.fire({
      title: 'Edit Session Time',
      html:
        `<div class='d-flex flex-row align-items-center justify-content-center'>
          <div class='form-group'>
            <label for='time_start'>Start Time</label>
            <input type='time' step="1800" id='time_start' class='form-control' value='${session?.time_start || ''}' />
          </div>
          <div class='form-group'>
            <label for='time_end'>End Time</label>
            <input type='time' step="1800" id='time_end' class='form-control' value='${session?.time_end || ''}' />
          </div>
        </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        const start_val = document.getElementById('time_start').value
        const end_val = document.getElementById('time_end').value
        const time_start = start_val ? moment(start_val, 'HH:mm').format('h:mm A') : ''
        const time_end = end_val ? moment(end_val, 'HH:mm').format('h:mm A') : ''

        if (index) {
          on.setInput(time_start, index, 'time_start')
          on.setInput(time_end, index, 'time_end')
        } else {
          setNewSession((prevState) => ({
            ...prevState,
            time_start,
            time_end
          }))
        }
      }
    })
  }

  const SetDaysAvailable  = () => {
    const daysOfWeek = [{ label: 'Monday', value: 'M', sort_by: 1 }, { label: 'Tuesday', value: 'T', sort_by: 2 }, { label: 'Wednesday', value: 'W', sort_by: 3 },
                        { label: 'Thursday', value: 'TH', sort_by: 4 }, { label: 'Friday', value: 'F', sort_by: 5 }]
    const currentDays = selectedSession?.days || []
    const [selectedDays, setSelectedDays] = useState(currentDays)

    return (
      <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Set Days Available</h5>
              <button type="button" className="close" onClick={() => setToggleDaysModal(false)}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {daysOfWeek.map(day => (
                <div key={day.value} className="d-inline-block mr-2 mb-2">
                  <button
                    className={"btn btn-outline-info" + (selectedDays.includes(day.value) ? ' active' : '')}
                    type="button"
                    value={day.value}
                    onClick={() => {
                      if (selectedDays.includes(day.value)) {
                        setSelectedDays(prev => prev.filter(d => d !== day.value))
                      } else {
                        setSelectedDays(prev => [...prev, day.value])
                      }
                    }}
                  >
                    {day.label}
                  </button>
                </div>
              ))}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setToggleDaysModal(false)}>Close</button>
              <button type="button" className="btn btn-primary" onClick={() => {
                const daysSorted = selectedDays.sort((a, b) => {
                  const dayA = daysOfWeek.find(d => d.value === a)
                  const dayB = daysOfWeek.find(d => d.value === b)
                  return dayA.sort_by - dayB.sort_by
                })
                if (selectedSession?.id) {
                  on.setInput(daysSorted, selectedSession.id, 'days')
                } else {
                  setNewSession((prevState) => ({
                    ...prevState,
                    days: daysSorted
                  }))
                }
                setToggleDaysModal(false)
              }}>Save</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const removeSession = (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "This session will be permanently deleted once you save the changes.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.isConfirmed) {
        setCustomSessions((prevSessions) => prevSessions.filter(s => s.id !== customSessions[index].id));
      }
    });
  }

  const handleDaysModal = (session, index = null) => {
    setSelectedSession({ ...session, id: index })
    setToggleDaysModal(prev => !prev)
  }

  const rows = customSessions.map((session, index) => {
    const sessionNumbParsed = session?.session_numb?.replace(/\D/g, '')
    return (
      <tr key={index}>
        <td>
          <select
            name='session_type'
            value={session?.session_type}
            onChange={ev => on.setInput(ev.target.value, index, ev.target.name)}
            className='form-control'
            required
          >
            <option value=''>Select Type</option>
            <option value='BHD'>BHD</option>
            <option value='BHE'>BHE</option>
            <option value='BI'>BI</option>
            <option value='BHR'>BHR</option>
            <option value='BHT'>BHT</option>
          </select>
        </td>
        <td colSpan={1} className='flex justify-content-end align-items-center'>
          <span className='mr-1'>{sessionNumbPrefix(session)}</span>
          <input 
            type='number'
            name='session_numb'
            style={{width: '86px'}}
            value={sessionNumbParsed}
            onChange={ev => on.setInput(ev.target.value, index, ev.target.name)}
            className='form-control'
            required
          />
        </td>
        <td colSpan={1}>
          <button
            className='btn btn-round btn-outline-info w-100'
            onClick={() => setDate(session, index)}
          >
            {setDateButtonText(session)}
          </button>
        </td>
        <td colSpan={1}>
          <button
            className='btn btn-round btn-outline-info w-100'
            onClick={() => setTime(session, index)}
          >
            {setTimeButtonText(session)}
          </button>
        </td>
        <td colSpan={1}>
          <button
            className='btn btn-round btn-outline-info w-100'
            onClick={() => handleDaysModal(session, index)}
          >
            {setDaysAvailableText(session)}
          </button>
        </td>
        <td colSpan={1} style={{backgroundColor: session?.active ? '#dfffdf' : '#ffd5d5'}}>
          <button
            name='active'
            className={`btn btn-round ${session?.active ? 'btn-outline-success' : 'btn-outline-danger'}`}
            style={{width: '58px'}}
            onClick={ev => on.setInput(!session?.active, index, ev.target.name)}
          >
            {session?.active ? 'Y' : 'N'}
          </button>
        </td>
        <td>
          <button
            type='button'
            className='btn btn-round btn-danger'
            style={{width: '160px'}}
            onClick={() => removeSession(index)}
          >
            Remove (-)
          </button>
        </td>
      </tr>
    )
  })

  // ******************* HANDLE NEW SESSION INPUTS AND SUBMISSION BELOW *******************

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewSession((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const submitNewSession = () => {
    // Add new session to customSessions list (with temporary id) and reset newSession state
    setCustomSessions((prevSessions) => {
      const sessionNumbWithPrefix = sessionNumbPrefix(newSession) + newSession.session_numb
      const newSessionWithId = { ...newSession, session_numb: sessionNumbWithPrefix, id: prevSessions.length, sort_by: newSession.session_numb.replace(/\D/g, '') };
      return [...prevSessions, newSessionWithId].sort((a, b) => b.sort_by - a.sort_by);
    });
    setNewSession({session_type: '', session_numb: '', month_start: '', month_end: '',
                   date_start: '', date_end: '', time_start: '', time_end: '', days: [], active: true});
  }

  const newSessionRow = (
    <tr key='newSession' className="pb-2">
      <td>
        <select
          name='session_type'
          value={newSession?.session_type}
          onChange={handleChange}
          className='form-control'
          required
        >
          <option value=''>Select Type</option>
          <option value='BHD'>BHD</option>
          <option value='BHE'>BHE</option>
          <option value='BI'>BI</option>
          <option value='BHR'>BHR</option>
          <option value='BHT'>BHT</option>
        </select>
      </td>
      <td colSpan={1} className='flex justify-content-end align-items-center'>
        <span className='mr-1'>{sessionNumbPrefix(newSession)}</span>
        <input 
          type='number'
          name='session_numb'
          style={{width: '86px'}}
          value={newSession?.session_numb}
          onChange={handleChange}
          className='form-control'
          required
        />
      </td>
      <td colSpan={1}>
        <button
          className='btn btn-round btn-outline-info w-100'
          onClick={() => setDate(newSession)}
        >
          {setDateButtonText(newSession)}
        </button>
      </td>
      <td colSpan={1}>
        <button
          className='btn btn-round btn-outline-info w-100'
          onClick={() => setTime(newSession)}
        >
          {setTimeButtonText(newSession)}
        </button>
      </td>
      <td colSpan={1}>
        <button
          className='btn btn-round btn-outline-info w-100'
          onClick={() => handleDaysModal(newSession)}
        >
          {setDaysAvailableText(newSession)}
        </button>
      </td>
      <td colSpan={1} style={{backgroundColor: newSession?.active ? '#dfffdf' : '#ffd5d5'}}>
        <button
          name='active'
          className={`btn btn-round ${newSession?.active ? 'btn-outline-success' : 'btn-outline-danger'}`}
          style={{width: '58px'}}
          onClick={ev => setNewSession((prevState) => ({ ...prevState, active: !prevState?.active }))}
        >
          {newSession?.active ? 'Y' : 'N'}
        </button>
      </td>
      <td>
        <button
          type='button'
          className='btn btn-round btn-info'
          style={{width: '160px'}}
          onClick={() => submitNewSession()}
        >
          Add Session +
        </button>
      </td>
    </tr>
  )

  // Handle Save Changes
  const saveChanges = () => {
    Swal.fire({
      title: 'Save Changes?',
      text: "Are you sure you want to save the changes made to the sessions?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, save changes!',
      cancelButtonText: 'No, keep editing'
    }).then((result) => {
      if (result.isConfirmed) {
        submitSessions()
      }
    });

    const submitSessions = () => {
      // Remove temporary id and sort_by fields before submitting to backend
      const sessionsToSubmit = customSessions.map(({ id, sort_by, ...session }) => session);

      // return console.log('Submitting sessions: ', { json_data: sessionsToSubmit.map(item => JSON.stringify(item)) });

      $app.axios.put(`/services/metadata/${metaData?.id}`, { json_data: sessionsToSubmit.map(item => JSON.stringify(item)) })
        .then(() => {
          toastr.success('Sessions updated successfully');
        })
        .catch(() => {
          toastr.error('There was an error updating the sessions');
        });
    }
  }

  return (
    <>
      <p>Edit session data by clicking on the relevant fields</p>
      <div className="d-flex justify-content-end align-items-center mb-3">
        <button className='btn' style={{backgroundColor: '#6e7d88', color: '#fff'}} onClick={() => closeModal()}>Close</button>
        <button className='btn btn-warning ml-2' onClick={saveChanges}>Save</button>
      </div>
      {loading ? <p>
          <div className="d-flex">
            <span>Loading sessions...</span>
            <div className='animate-spin'>
              <i className='fas fa-circle-notch' />
            </div>
          </div>
        </p> : (
        <>
          <table className='table table-hover'>
            <thead>
              <tr>
                <th scope='col'>Session Type</th>
                <th scope='col'>Session Number</th>
                <th scope='col'>Date</th>
                <th scope='col'>Time</th>
                <th scope='col'>Days Available</th>
                <th scope='col'>Active</th>
              </tr>
            </thead>
            <tbody>
              {newSessionRow}
              <tr><td colspan="5" style={{height:"40px"}}></td></tr>
              {rows}
            </tbody>
          </table>
          <div className="d-flex justify-content-end align-items-center mt-3">
            <button className='btn' style={{backgroundColor: '#6e7d88', color: '#fff'}} onClick={() => closeModal()}>Close</button>
            <button className='btn btn-warning ml-2' onClick={saveChanges}>Save</button>
          </div>
        </>
      )}
      {/* Toggle Visibility of Days for a Session Modal */}
      {toggleDaysModal && <SetDaysAvailable />}
    </>
  )
}

export default SessionTableModify